module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/user-d7de469873639d538d74795d6beeabbe.svg";